package br.com.texeratx.boardgametimeapp.core.active_match

/**
 * Rascunho de pontuação por jogador (ainda não salva no backend).
 */
data class PlayerScoreDraft(
    val playerId: Long,
    val playerName: String,
    val pointsText: String = "" // o usuário digita aqui
)
